<template>
  <span :class="computedClass">
    {{ $t(`models.project_lead.sync_statuses.${label}`) }}
  </span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    computedClass(){
      let classes = ["sensual-badge"]
      let status  = this.item.sync_status
      if (this.item.sync_disabled) {
        classes.push('grey-dark')
      } else if (status === 'not_synced') {
        classes.push('yellow')
      } else if (status === 'not_sync_ready') {
        classes.push('grey')
      } else if (status === 'sync_ready') {
        classes.push('indigo')
      } else if (status === 'processing') {
        classes.push('blue')
      } else if (status === 'sync_error') {
        classes.push('red')
      } else if (status === 'synced') {
        classes.push('green')
      }
      return classes
    },
    label() {
      if (this.item.sync_disabled) {
        return 'sync_disabled'
      }
      return this.item.sync_status
    }
  }
}
</script>
<style lang="scss" scoped>
.sensual-badge {
  font-size: 12px;
  padding: 1px 7px 1px 7px;
  border-radius: 3px;
  display: inline-flex;
}
.crm-status-not_synced{
  background-color: $paper-light;
  color: $ink;
}
.crm-status-not_sync_ready{
  background-color: $yellow-lighter;
  color: $yellow-dark;
}
.crm-status-sync_disabled{
  background-color: $paper;
  color: $ink;
}
.crm-status-sync_ready{
  background-color: $indigo-lighter;
  color: $indigo-dark;
}
.crm-status-processing{
  background-color: $sensual-lighter;
  color: $sensual-dark;
}
.crm-status-sync_error{
  background-color: $red-lighter;
  color: $red-dark;
}
.crm-status-synced{
  background-color: $green-lighter;
  color: $green-dark;
}
</style>



// WEBPACK FOOTER //
// CollectionValueCrmStatus.vue?2256e6ff